import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getProduct } from '../../api/products';
import { Breadcrumbs } from '../../components/ui/Breadcrumbs';
import { ProductGallery } from '../../components/product/ProductGallery';
import { ProductInfo } from '../../components/product/ProductInfo';
import { Seo } from '../../components/seo';
import { SITE } from '../../config/site';
import { productSeo } from '../../config/seo';
import { buildBreadcrumbJsonLd } from '../../seo/buildBreadcrumbJsonLd';
import { buildProductJsonLd } from '../../seo/buildProductJsonLd';
import styles from './ProductPage.module.css';

export function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    getProduct(id)
      .then((data) => setProduct(data.product))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className={`container ${styles.page}`}>
        <Seo title={`Загрузка товара — ${SITE.name}`} noindex description={SITE.description} />
        <div className={styles.skeleton} />
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className={`container ${styles.page}`}>
        <Seo
          title={`Товар не найден — ${SITE.name}`}
          description="Товар не найден в каталоге nextcake."
          noindex
        />
        <p className={styles.error}>{error || 'Товар не найден'}</p>
      </div>
    );
  }

  const category = product.categories?.[0];
  const seo = productSeo(product);

  const breadcrumbs = [
    { label: 'Главная', to: '/' },
    category
      ? { label: category.name, to: `/catalog?category=${category.id}` }
      : { label: 'Каталог', to: '/catalog' },
    { label: product.name },
  ];

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        image={seo.image}
        type="product"
        jsonLd={[buildProductJsonLd(product), buildBreadcrumbJsonLd(breadcrumbs)]}
      />

      <Breadcrumbs items={breadcrumbs} />

      <div className={styles.layout}>
        <ProductGallery
          images={product.images}
          tags={product.tags}
          alt={`${product.name} — купить в магазине nextcake, Волгоград`}
        />
        <ProductInfo product={product} />
      </div>
    </div>
  );
}
